module.exports = __webpack_public_path__ + "static/media/firstMeetingBackground.3e5225f2.jpg";